import axios from "axios";
import { UpdateAppData } from "../redux/types/UpdateAppType";
import { BusinessDetailsType } from "../pages/types/BusinessDetailsType";
import { getSessionId } from "../../../../../utils/tokenHandlers";

export const deleteKpDocument = (customerId: number, data: any) => {
  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer_key_person/${customerId}`,
      {
        params: {
          context: {},
          data: data,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((err) => err);
};
